import { Component, OnInit } from '@angular/core';
import { AdminApiService, AdminServiceItem } from '../../../core/services/admin-api.service';

@Component({
    selector: 'app-admin-services',
    templateUrl: './admin-services.component.html'
})
export class AdminServicesComponent implements OnInit {

    services: AdminServiceItem[] = [];

    model: AdminServiceItem = {
        id: 0,
        title: '',
        description: '',
        iconKey: '',
        ctaText: '',
        ctaUrl: '',
        sort: 0,
        status: true
    };

    iconKeys = [
        'warehousing',
        'rental',
        'manufacturing',
        'testing',
        'supply',
        'liquid-control'
    ];

    loading = false;
    saving = false;
    errorMessage = '';
    successMessage = '';

    constructor(private adminApi: AdminApiService) { }

    ngOnInit(): void {
        this.getServices();
    }

    getServices(): void {
        this.loading = true;
        this.errorMessage = '';

        this.adminApi.getAdminServices().subscribe(
            (data: AdminServiceItem[]) => {
                this.services = data || [];
                this.loading = false;
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Services could not be loaded.';
                this.loading = false;
            }
        );
    }

    newService(): void {
        this.model = {
            id: 0,
            title: '',
            description: '',
            iconKey: '',
            ctaText: '',
            ctaUrl: '',
            sort: 0,
            status: true
        };

        this.successMessage = '';
        this.errorMessage = '';
    }

    editService(item: AdminServiceItem): void {
        this.model = {
            id: item.id,
            title: item.title,
            description: item.description,
            iconKey: item.iconKey,
            ctaText: item.ctaText,
            ctaUrl: item.ctaUrl,
            sort: item.sort,
            status: item.status
        };

        this.successMessage = '';
        this.errorMessage = '';
    }

    saveService(): void {
        this.successMessage = '';
        this.errorMessage = '';

        if (!this.model.title || !this.model.description) {
            this.errorMessage = 'Title and description are required.';
            return;
        }

        this.saving = true;

        this.adminApi.saveAdminService(this.model).subscribe(
            () => {
                this.saving = false;
                this.successMessage = 'Service saved successfully.';
                this.newService();
                this.getServices();
            },
            (error) => {
                console.error(error);
                this.saving = false;
                this.errorMessage = 'Service could not be saved.';
            }
        );
    }

    deleteService(id: number): void {
        if (!confirm('Delete this service?')) {
            return;
        }

        this.adminApi.deleteAdminService(id).subscribe(
            () => {
                this.successMessage = 'Service deleted.';
                this.getServices();
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Service could not be deleted.';
            }
        );
    }
}